module.exports = __webpack_public_path__ + "static/media/Notice Blue.6f181c04.svg";